
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

interface StoreItem {
  id: string | number;
  storeName: string;
  companyName: string;
  storeHeadPortrait?: string;
}

@Component({
  name: 'SelectMultiStoreRange'
})
export default class SelectMultiStoreRange extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean
  @Prop({ type: Array, default: () => [] }) storeList!: StoreItem[]
  @Prop({ type: Array, default: () => [] }) selectedIds!: (string | number)[]

  visible = false
  localSelectedIds: (string | number)[] = []

  @Watch('value')
  onValueChange(val: boolean) {
    this.visible = val
    if (val) {
      // 打开时初始化选中状态
      this.localSelectedIds = [...this.selectedIds]
      // 如果没有传入选中的，默认全选？或者根据业务需求，这里暂时保持传入的状态
    //   if (this.localSelectedIds.length === 0 && this.storeList.length > 0) {
          // 默认全选方便演示，或者留空
          // this.localSelectedIds = this.storeList.map(s => s.id)
    //   }
    }
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.$emit('input', val)
  }

  toggleSelect(id: string | number) {
    const index = this.localSelectedIds.indexOf(id)
    if (index > -1) {
      this.localSelectedIds.splice(index, 1)
    } else {
      this.localSelectedIds.push(id)
    }
  }

  onCancel() {
    this.visible = false
    this.$emit('cancel')
  }

  onConfirm() {
    if (this.localSelectedIds.length < 2) {
      this.$toast('至少选择2家店铺')
      return
    }
    this.visible = false
    this.$emit('confirm', this.localSelectedIds)
  }
}
